import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../../config.js';
import Loading from './../../../components/loading.js';

import Actionsheets from './../../../components/actionsheets.js';
import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class ProjectRelatedPetList extends React.Component {
	constructor(props) {
		super(props);
		console.log(props);
		let user = {};
		let uistyle = {};
		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
			if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
				uistyle = JSON.parse(user.company.type);
			}
		}
		let pathurl = props.pathurl;
		this.state = {
			user: user,
			projectid: 0,
			type: props.data.type,
			loading: true,
			isaction: false,
			tasks: [],
			actiontaskid: '',
			avoidReSubmit: {},
			uistyle:uistyle,
			pathurl:pathurl,
			search: ''
		}


		this.actionClose = this.actionClose.bind(this);
		this.actionSubmit = this.actionSubmit.bind(this);
		this.removeTask = this.removeTask.bind(this);
		this.reSubmit = this.reSubmit.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
	}


	componentDidMount() {
		this.onInitial(this.props.data);
	}

	componentWillReceiveProps(nextProps) {
		//this.onInitial(nextProps.data);
	}

	notify(message) {
		notification.notice({
			content: message,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}

	actionClose() {
		this.setState({
			isaction: false,
			actiontaskid: ''
		})
	}

	getProgress() {
		const {
			tasks
		} = this.state;
		let postdata = {
			ids: []
		}
		tasks.forEach((ele, index) => {
			if (ele.status >= 0 && ele.status!=2) {
				postdata.ids.push(ele.id);
			}
		});
		if( !postdata.ids.length ) return;
		fetch(config.host + '/pet_service/updateUiPetStatus', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				if (json.status == 1) {
					json.data.forEach((ele, i) => {
						this.state.tasks.forEach((one, index) => {
							if (ele.id == one.id) {
								one.status = ele.status;
								one.complete_per = ele.complete_per;
								if (ele.status == 2) {
									one.complete_per == 100;
								}
							}
						});
					});
					this.setState(this.state.tasks);
				}
			}).catch(function(error) {
				console.log(error);
			});
	}

	onInitial(data) {
		const me = this;
		const {
			projectid,
			user,
			search
		} = me.state;
		const {
			type
		} = data;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			type: type,
			search: search,
			request: 'getpetlist',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});

		fetch(config.host + '/brainlabel/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				if (json.status === 1) {
					me.setState({
						tasks: json.data,
						loading: false
					});
					json.data.forEach(t => {
						if (t.status === '1' || t.status === '0') {
							me.getusertask(t.id, t.task_id);
						}
					})
				} else {
					me.setState({
						tasks: [],
						loading: false
					});
				}

				setInterval(() => {
					this.getProgress();
				}, 15000);
			}).catch(function(error) {
				console.log(error);
			});
	}

	//get brainlabel task status as percent
	getusertask(taskid, brainlabelid) {
		const me = this;
		const {
			user,
			projectid,
			tasks
		} = me.state;

		const postdata = {
			taskid: taskid,
			brainlabelid: brainlabelid,
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			request: 'getusertask',
			Authorization: localStorage.token
		};

		fetch(config.host + '/brainlabel/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				if (json.status === 1) {
					tasks.forEach(t => {
						if (t.id === taskid) {
							t.status = json.data.task_state;
							t.percent = json.data.complete_per;
						}
					});

					me.setState({
						tasks: tasks
					});
				} else {
					//me.notify(json.message);
				}
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	actionSubmit(id) {
		this.setState({
			actiontaskid: id,
			isaction: true
		})
	}

	reSubmit(data) {
		console.log(data)
		const me = this;
		const {
			user,
			projectid,
			tasks
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			Authorization: localStorage.token,
			data: data,
		};
		if (me.state.avoidReSubmit[data.id]) {
			me.notify('操作过于频繁.');
			return;
		}

		me.state.avoidReSubmit[data.id] = true;
		me.setState(me.state.avoidReSubmit);

		fetch(config.host + '/pet_service/retask', {
				method: 'post',
				body: JSON.stringify(postdata)
			}).then(res => res.json())
			.then(json => {
				let tag = 0;
				if (json.status == 1) {
					tasks.forEach((ele, i) => {
						if (ele.id == data.id) {
							tasks.splice(i, 1);
							tag = i;
						}
					});
					me.setState({
						tasks: tasks
					});
					setTimeout(() => {
						tasks.splice(tag, 1, json.data);
						me.setState({
							tasks: tasks
						});
					}, 1000);
				}
				me.notify(json.message);

			}).catch(function(error) {
				console.log(error);
			});

		setTimeout(() => {
			me.state.avoidReSubmit[data.id] = false;
			me.setState(me.state.avoidReSubmit);
		}, 4000);
	}

	removeTask() {
		const me = this;
		let {
			user,
			actiontaskid,
			projectid,
			tasks
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			taskid: actiontaskid,
			request: 'remove',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		//console.log(postdata);
		fetch(config.host + '/brainlabel/index', {
				method: 'post',
				body: JSON.stringify(postdata)
			})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					tasks.map((t, i) => {
						if (t.id === actiontaskid) {
							tasks.splice(i, 1);
						}
						return t;
					});
					me.setState({
						tasks: tasks
					});
				}
				me.setState({
					loading: false,
					isaction: false
				});
			}).catch(function(error) {
				console.log(error);
			});
	}

	handleInputChange(event) {
		const me = this;
		const target = event.target;
		const name = target.name;
		const value = target.value;
		me.setState({
			[name]: value
		})
	}

	handleSubmit(event) {
		event.preventDefault();
		event.stopPropagation();
		this.onInitial(this.props.data);
		return;
	}

	onKeyDown(event: React.KeyboardEvent < HTMLDivElement > ) {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
			this.handleSubmit();
		}
	}

	render() {
		const {
			user,
			projectid,
			tasks,
			uistyle,
			pathurl
		} = this.state;
		let tbody = null;
		if (tasks.length) {
			tbody = tasks.map((m, i) => {
				var type = '-';
				switch (m.type_name) {
					case 'PT':
						type = 'AV133';
						break;
					case 'PTMR':
						type = 'PET + MRI';
						break;
					case 'PTCT':
						type = 'PET + CT';
						break;
				}
				return (
					<tr key={i} data-id={m.id} style={{ display: m.status != -1 ? '' : 'none' }}>
						<td><Link to={`/console/subject_files/${m.project_id || 0}/${m.subject_id}/0/?to=${pathurl}`} title={`序列编号:${m.input_patientid} (${m.file_id}) `}>{m.subject_number || m.input_patientid || m.file_id} </Link></td>
						{uistyle.is_subjectuid && <td>{m.subject_uid}</td> }
						<td>{type}</td>
						<td>{m.subject_gender == 0 ? '男' : '女'}</td>
						<td>{m.subject_age}</td>
						<td className="small">{m.date_created}</td>
						<td className="small">{m.date_update}</td>
						<td>
							{
								m.status == 1 &&
								<div className="progress">
									<div className="progress-bar progress-bar-striped progress-bar-animated " style={{ width: m.complete_per + '%' }} aria-valuenow={m.complete_per} aria-valuemin="0" aria-valuemax="100">{m.complete_per}%</div>
								</div>
							}
							{
								m.status == 2 &&
								<span className="text-success"> 处理完成 </span>
							}
							{
								m.status == 3 &&
								<span className="text-danger"> 处理失败 </span>
							}
							{
								m.status == 0 &&
								<span className="text-danger"> 待处理 </span>
							}

						</td>
						<td>
							{(() => {
								if (m.status === '2') {
									const links = {
										download: config.host + '/brainlabel/index_get/download_data/' + user.company_id + '/' + user.id + '/' + projectid + '/' + m.id + '/' + localStorage.token,
										view: config.host + '/brainlabel/index_get/show_brain/' + user.company_id + '/' + user.id + '/' + projectid + '/' + m.id + '/' + localStorage.token,
										petviewer: config.petviewer + '?type=' + m.type_name + '&tid=' + m.task_id + '&cid=' + m.company_id + '&keyid=' + m.id + '&requrl=/petview/index/&host=' + config.host + '&token=' + localStorage.token,
									};
									return (
										<div>
											<span className="mx-2">
												<a className="text-body" href={links.petviewer} target="_blank"><i className="fa fa-brain text-success" title={m.id}></i>Pet阅片</a>
											</span>

											<span className="ml-2"><a className="text-danger remove" onClick={() => { this.actionSubmit(m.id) }} title={m.id}>删除</a></span>
										</div>
									)
								} else {
									return (
										<div>
										    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											<a className="text-danger remove" onClick={() => { this.actionSubmit(m.id) }}>删除</a>
											{this.state.avoidReSubmit[m.id]}
											&nbsp;&nbsp;&nbsp;&nbsp;
											<a className={this.state.avoidReSubmit[m.id] ? 'text-muted' : 'text-success'} onClick={() => { this.reSubmit(m) }} title={m.id}>重提交</a>
										</div>
									)
								}
							})()}
						</td>
					</tr>)
			});
		}
		return (
			<div>
				<Loading display={this.state.loading} />
				<nav className="clearfix mb-3">
					<h4 className="animated fadeInLeft float-left"><i className="fa fa-data"></i> PET分析列表 <small>共{tasks.length}条</small></h4>
					<div className="float-right">
						<form className="form-inline" onSubmit={this.handleSubmit}>
							<div className="form-group">
								<input type="search" name="search" className="form-control form-control-sm" placeholder="受试者编号或创建日期等等" onChange={this.handleInputChange} onBlur={this.handleSubmit} value={this.state.search} />
							</div>
							<button type="submit" className="btn btn-dark btn-sm">搜索</button>
						</form>
					</div>
				</nav>
				<table className="table table-hover">
					<thead className="thead-dark">
						<tr>
							<th>受试者</th>
							{uistyle.is_subjectuid && <th>UID</th> }
							<th>类型</th>
							<th>性别</th>
							<th>年龄</th>
							<th>提交时间</th>
							<th>更新时间</th>
							<th>状态</th>
							<th className="text-right">操作</th>
						</tr>
					</thead>
					<tbody>{tbody}</tbody>
				</table>
				<Actionsheets display={this.state.isaction}>
					<ul className="list-group text-center">
						<li className="list-group-item disabled">确定要删除?</li>
						<li className="list-group-item text-danger" onClick={this.removeTask}>删除</li>
						<li className="list-group-item" onClick={this.actionClose}>取消</li>
					</ul>
				</Actionsheets>
			</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/list_pet.js